// extracted by mini-css-extract-plugin
module.exports = {"deprecation-header":"deprecation-header-aKl9j","deprecationHeader":"deprecation-header-aKl9j","text":"text-1dpnF","actions":"actions-3o9AE","action":"action-1vVRH"};